import { render, staticRenderFns } from "./WarrantyClaimForm.vue?vue&type=template&id=047dd9db&"
import script from "./WarrantyClaimForm.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports